import React, { useContext } from "react";
import Accordion from "../../common/Accordion";
import Spheres from "../Spheres";
import { textData as data } from "../../content/data/ExpandablesData";
import { ExpandablesContainer } from "./styles";
import Team from "../Team";
import Goods from "../Goods";
import { RefContext } from "../AppContext";
import Contact from "../Contact";

const Expandables = () => {
  const {
    setSpheresBlock,
    spheresBlock,
    setGoodsBlock,
    goodsBlock,
    setUsBlock,
    usBlock,
    contactBlock,
    setContactBlock,
    competentsBlockRef,
    goodsBlockRef
  } = useContext(RefContext);

  return (
    <ExpandablesContainer ref={competentsBlockRef}>
      <div>
        <Accordion
          opened={spheresBlock}
          setOpened={setSpheresBlock}
          title={data.title1}
          secondTitle={data.secondTitle1}
        >
          <Spheres />
        </Accordion>
      </div>
      <div ref={goodsBlockRef}>
        <Accordion
          opened={goodsBlock}
          setOpened={setGoodsBlock}
          title={data.title2}
          secondTitle={data.secondTitle2}
        >
          <Goods />
        </Accordion>
      </div>
      {/* <div>
        <Accordion
          opened={usBlock}
          setOpened={setUsBlock}
          title={data.title3}
          secondTitle={data.secondTitle3}
        >
          <Team />
        </Accordion>
      </div> */}
      {/* <Accordion
        opened={socialBlock}
        setOpened={setSocialBlock}
        title={data.title4}
        secondTitle={data.secondTitle4}
      >
        <Social/>
      </Accordion> */}
      <div>
        <Accordion
          opened={contactBlock}
          setOpened={setContactBlock}
          title={data.title5}
          secondTitle={data.secondTitle3}
        >
          <Contact/>
        </Accordion>
      </div>
    </ExpandablesContainer>
  );
};

export default Expandables;
